import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import style from "../common.module.scss"
import { Order } from '../../../../services';
import UserProfileIcon from '../../../shared/icons/UserProfileIcon';
import TransportCoveredIconNew from '../../../shared/icons/TransportCoveredIconNew';
import moment from 'moment';
import DocumentIconNew from '../../../shared/icons/DocumentIconNew';
import generatePOA from '../../../../utils/generate_poa';
import DriverDocumentViewer from './DriverDocumentViewer';
import {useSelector} from "react-redux";
import {t} from "i18next";

const OrdersDriverInfo = ({ item, driverId = null, senderName, recipientName, bookingDate = '', listDocDriver = '', isExecutor = false }) => {
    const [driverInfo, setDriverInfo] = useState(null);
    const [vehicleIdInfo, setVehicleInfo] = useState(null);
    const [showModalDocumentViewer, setShowModalDocumentViewer] = useState(false);
    const {user} = useSelector(state => state);

    const handleGeneratePOA = () => {
        generatePOA({
            carModel: driverInfo.carModel,
            carNumber: driverInfo.carNumber,
            trailerNumber: driverInfo.trailerNumber,
            idNumber: driverInfo.idNumber,
            issuedDate: driverInfo.issuedDate,
            issuedBy: driverInfo.issuedBy,
        }, {
            surname: driverInfo.surname,
            name: driverInfo.name,
            patronymic: driverInfo.patronymic,
        }, senderName, recipientName, item.number, item.shippingDate, item.unloadingDate, user.isNDS);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };

        let formattedDate = date.toLocaleDateString('ru-RU', options);

        return formattedDate;
    };

    const truncateText = (text, maxLength) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };      

    useEffect(() => {
        if (!driverId) {
            console.log("driverId не предоставлен");

            return;
        }

        if (driverId) {
            Order.getDriverInfo(driverId)
                .then(response => {
                    if (response.status == 200) {
                        setDriverInfo(response.data ? response.data : {});
                        console.log("driverInfo =", response.data)
                    } else {
                        setDriverInfo(null)
                    }
                }).catch(error => {
                console.log("Ошибка при получении информации о водителе:", error);
            });
        }

        if (item?.vehicleId) {
            Order.getVehicleInfo(item.vehicleId)
            .then(response => {
                if (response.status == 200) {
                    setVehicleInfo(response.data);
                    console.log("vehicleInfo =", response.data)
                } else {
                    setVehicleInfo(null)
                }
            }).catch(error => {
                console.log("Ошибка при получении информации о vehicleInfo:", error);
            });
        }
    }, [driverId])

    return (
        <div className={cn(style.cargo_wrapper)}>
            <div className={cn(style.cargo_title, style.orders_title,)}>
                {t('orderInfo.executor')} {isExecutor && (item?.isPublic && item?.type === 1 ? "binY" : truncateText(user?.companyName, 20))}
            </div>
       
            <div className={style.driver_content}>
                <div className={style.driver_details}>
                    <div className={style.driver_details_text}>{t('orderInfo.driver')}</div>
                    <div className={style.driver_details_content}>
                        <div className={style.driver_details_icon}><UserProfileIcon /></div>
                        <div className={style.driver_details_info}>
                            <div className={style.driver_details_title}>
                                {driverInfo && driverInfo.surname ? `${driverInfo.name}.${driverInfo.surname.charAt(0).toUpperCase()}` : ''}
                            </div>
                            <div className={style.driver_details_text}>{t('orderInfo.iin')} {driverInfo?.iin}</div>
                        </div>
                    </div>
                </div>
                <div className={style.driver_details}>
                    <div className={style.driver_details_text}>{t('orderInfo.transport')}</div>
                    <div className={style.driver_details_content}>
                        <div className={style.driver_details_icon}><TransportCoveredIconNew /></div>
                        <div className={style.driver_details_info}>
                            <div className={style.driver_details_title}>{driverInfo?.carModel || vehicleIdInfo?.carModel}</div>
                            <div className={style.driver_details_text}>{driverInfo?.carNumber || vehicleIdInfo?.carNumber}</div>
                        </div>
                    </div>
                </div>
                <div className={style.driver_details}>
                    <div className={style.driver_details_text}>{t('orderInfo.documents')}</div>
                    <div className={style.driver_details_info}>
                        <div className={style.driver_details_title}>{t('orderInfo.identityCard')}</div>
                        <div className={style.driver_details_text}>
                            №{driverInfo?.idNumber}・{moment(driverInfo?.issuedDate).format("DD MMMM YYYY")}・{driverInfo?.issuedBy}
                        </div>
                    </div>
                </div>
                <div className={style.driver_details}>
                    <div className={style.driver_details_text}>{t('orderInfo.downloadDocument')} </div>
                    <div className={style.driver_details_content}>
                        <div className={style.driver_details_docx}><DocumentIconNew type={2} /></div>
                        <div className={style.driver_details_info}>
                            <div className={style.driver_details_link} onClick={handleGeneratePOA}>{t('orderInfo.downloadAttorney')}</div>
                            <div className={style.driver_details_text}>№{item.number} {t('orderInfo.from')} {formatDate(bookingDate)}</div>
                        </div>
                    </div>
                </div>
                <div className={style.driver_details}>
                    <div className={style.driver_details_text}>{t('orderInfo.driverDocuments')}</div>
                    <div className={style.driver_details_content}>
                        <div className={style.driver_details_docx}><DocumentIconNew type={2} /></div>
                        <div className={style.driver_details_info}>
                            <div className={style.driver_details_link} onClick={() => setShowModalDocumentViewer(true)}>{t('orderInfo.viewDocuments')}</div>
                            <div className={style.driver_details_text}>№{item.number} {t('orderInfo.from')} {formatDate(bookingDate)}</div>
                        </div>
                    </div>
                </div>
            </div>
            {showModalDocumentViewer && (
                <DriverDocumentViewer setShowModal={setShowModalDocumentViewer} documents={listDocDriver} />
            )}
        </div>
    );
};

export default OrdersDriverInfo;